export const RATE_DETAILS_LIST_REQUEST = "RATE_DETAILS_LIST_REQUEST"
export const RATE_DETAILS_LIST_SUCCESS = "RATE_DETAILS_LIST_SUCCESS"
export const RATE_DETAILS_LIST_FAILED = "RATE_DETAILS_LIST_FAILED"

export const RATE_DETAILS_GET_REQUEST = "RATE_DETAILS_GET_REQUEST"
export const RATE_DETAILS_GET_SUCCESS = "RATE_DETAILS_GET_SUCCESS"
export const RATE_DETAILS_GET_FAILED = "RATE_DETAILS_GET_FAILED"

export const RATE_DETAILS_UPDATE_REQUEST = "RATE_DETAILS_UPDATE_REQUEST"
export const RATE_DETAILS_UPDATE_SUCCESS = "RATE_DETAILS_UPDATE_SUCCESS"
export const RATE_DETAILS_UPDATE_FAILED = "RATE_DETAILS_UPDATE_FAILED"

export const RATE_DETAILS_UPDATE_SORT_ORDER_REQUEST = "RATE_DETAILS_UPDATE_SORT_ORDER_REQUEST"
export const RATE_DETAILS_UPDATE_SORT_ORDER_SUCCESS = "RATE_DETAILS_UPDATE_SORT_ORDER_SUCCESS"
export const RATE_DETAILS_UPDATE_SORT_ORDER_FAILED = "RATE_DETAILS_UPDATE_SORT_ORDER_FAILED"

export const RATE_DETAILS_PROCESS_CLEAR = "RATE_DETAILS_PROCESS_CLEAR"


export type RateContent = {
    lang?: string;
    display_name: string;
    description: string;
}

export type RateData = {
    id: number | null;
    rate_code: string;
    name: string | null;
    contents: RateContent[];
    sort_order?: number;
    enabled: boolean;
}

export type SortOrderItem = {
    rate_id: number
    sort_order: number
}

export type RateDetailsListResponse = RateData[]

export type RateDetailsGetRequestPayload = {
    rateCode: string
}

export type RateDetailsUpdateRequestPayload = {
  prop_code: string
} & RateData

export type RateDetailsUpdateSortOrderRequestPayload = {
    prop_code: string
    items: SortOrderItem[]
}

export type RateDetailsListRequest = {
    type: typeof RATE_DETAILS_LIST_REQUEST
}

export type RateDetailsListSuccess = {
    type: typeof RATE_DETAILS_LIST_SUCCESS
    payload: RateDetailsListResponse
}

export type RateDetailsListFailed = {
    type: typeof RATE_DETAILS_LIST_FAILED
    payload: string
}

export type RateDetailsGetRequest = {
    type: typeof RATE_DETAILS_GET_REQUEST
    payload: RateDetailsGetRequestPayload
}

export type RateDetailsGetSuccess = {
    type: typeof RATE_DETAILS_GET_SUCCESS
    payload: RateData
}

export type RateDetailsGetFailed = {
    type: typeof RATE_DETAILS_GET_FAILED
    payload: string
}

export type RateDetailsUpdateRequest = {
    type: typeof RATE_DETAILS_UPDATE_REQUEST
    payload: RateData
}

export type RateDetailsUpdateSuccess = {
    type: typeof RATE_DETAILS_UPDATE_SUCCESS
}

export type RateDetailsUpdateFailed = {
    type: typeof RATE_DETAILS_UPDATE_FAILED
    payload: string
}

export type RateDetailsUpdateSortOrderRequest = {
    type: typeof RATE_DETAILS_UPDATE_SORT_ORDER_REQUEST
    payload: SortOrderItem[]
}

export type RateDetailsUpdateSortOrderSuccess = {
    type: typeof RATE_DETAILS_UPDATE_SORT_ORDER_SUCCESS
}

export type RateDetailsUpdateSortOrderFailed = {
    type: typeof RATE_DETAILS_UPDATE_SORT_ORDER_FAILED
    payload: string
}

export type RateDetailsProcessClear = {
    type: typeof RATE_DETAILS_PROCESS_CLEAR
}

export type RateDetailsConfigAction =
    | RateDetailsListRequest
    | RateDetailsListSuccess
    | RateDetailsListFailed
    | RateDetailsGetRequest
    | RateDetailsGetSuccess
    | RateDetailsGetFailed
    | RateDetailsUpdateRequest
    | RateDetailsUpdateSuccess
    | RateDetailsUpdateFailed
    | RateDetailsUpdateSortOrderRequest
    | RateDetailsUpdateSortOrderSuccess
    | RateDetailsUpdateSortOrderFailed
    | RateDetailsProcessClear
